var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mesAccueils',_vm._b({},'mesAccueils',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }